import { ID_TOKEN_COOKIE } from '../global-constants';
import { getCookie } from '../helpers/cookies';
import decodeIdToken from '../utils/decodeIdToken';
import getLoggedInUserInfo from '../utils/getLoggedInUserInfo';
import { getSecureTwoURL } from './getters';
export var ACCESS_TOKEN_COOKIE = 'access_token';
export var EMAIL_COOKIE = 'email';
export var OPERA_COMPANY_ID = 'https://premierinn.com/operaCompanyId';
export var CDH_COMPANY_ID = 'https://premierinn.com/companyAccountId';
export var CDH_EMPLOYEE_ID = 'https://premierinn.com/employeeAccountId';
export var MAX_AGE = 40 * 60 * 1000;
export function getAuthCookie() {
  return getCookie(ID_TOKEN_COOKIE) || '';
}
export function getAccessTokenCookie() {
  return getCookie(ACCESS_TOKEN_COOKIE) || '';
}
export function logout() {
  var authIframe = document.getElementById('authIframe');
  if (authIframe !== null && authIframe !== void 0 && authIframe.contentWindow) {
    var message = JSON.stringify({
      action: 'logout'
    });
    authIframe.contentWindow.postMessage(message, getSecureTwoURL());
  }
}
export { decodeIdToken, ID_TOKEN_COOKIE, getLoggedInUserInfo };